/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @author Evgenij Tyan
 * @version 1.1.0
 * @since 1.0.1
 */

import { createAction } from '../../../../../modules/app/createAction';
import {
    CLEAN_LIST_SUBSCRIBERS,
    LOAD_LIST_SUBSCRIBERS_MAX_COSTS_FAIL,
    LOAD_LIST_SUBSCRIBERS_MAX_COSTS_REQUEST,
    LOAD_LIST_SUBSCRIBERS_MAX_COSTS_SUCCESS,
} from './constants/widgetSubscriberMaxCostsConstants';
import {
    ILoadMaxCostsSuccessPayload,
    TCleanSubscriberMaxCostsAction,
    TLoadSubscriberMaxCostFailAction,
    TLoadSubscriberMaxCostRequestAction,
    TLoadSubscriberMaxCostSuccessAction,
} from './widgetSubscriberMaxCostsType';

/*
* -------------------------------------------
*        LOAD SUBSCRIBERS LIST WITH MAX COSTS
* -------------------------------------------
*/

export const widgetSubscriberMaxCostRequest = (): TLoadSubscriberMaxCostRequestAction =>
    createAction(LOAD_LIST_SUBSCRIBERS_MAX_COSTS_REQUEST);

export const widgetSubscriberMaxCostSuccess =
    (payload: ILoadMaxCostsSuccessPayload): TLoadSubscriberMaxCostSuccessAction =>
        createAction(LOAD_LIST_SUBSCRIBERS_MAX_COSTS_SUCCESS, payload);

export const widgetSubscriberMaxCostFail = (payload: string): TLoadSubscriberMaxCostFailAction =>
    createAction(LOAD_LIST_SUBSCRIBERS_MAX_COSTS_FAIL, payload);

export const cleanListSubscriberMaxCosts = (): TCleanSubscriberMaxCostsAction =>
    createAction(CLEAN_LIST_SUBSCRIBERS);

